import { withStyles } from "@material-ui/core/styles";
import { TableCell } from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
  root: {
    borderTop: "none !important",
    borderBottom: "none !important",
  },
  head: {
    backgroundColor: "#F7FAFF",
    color: "none",
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "15px",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default StyledTableCell;
